export const mainRoutes = [
  {
    name: 'Company',
    subRoutes: [
      { name: 'About Us', to: '/about' },
      { name: 'Portal', to: '/login' },
    ]
  },

  {
    name: 'Products',
    subRoutes: [
      { name: 'Utility Solutions', to: '/utility' },
      { name: 'Fire Agency Solutions', to: '/fire-agency' },
      { name: 'HRL Detector', to: '/hrl-detector' },
    ]
  },

  // { name: 'Discover', to: '/news' },

  {
    name: 'Discover',
    subRoutes: [
      { name: 'Careers', to: '/careers' },
      { name: 'News', to: '/news' },
      { name: 'FountaiNN', to: '/fountainn' },
    ]
  },
];

export const LoggedRoutes = [ 
  {
    name: 'Access',
    subRoutes: [
      { name: 'Esri Dashboard', to: '/fnn_portal_esri' },
      { name: 'Product Suite', to: '/fnn_portal_product_suite' },
    ]
  },

  {
    name: 'Resources',
    subRoutes: [
      { name: 'Detector Information', to: '/fnn_portal_map' },
      { name: 'Installation Manual', to: '/fnn_portal_manual' },
      { name: 'Tutorial Videos', to: '/fnn_portal_video_hub' },
    ]
  },

  {
    name: 'Support',
    subRoutes: [
      { name: 'FNN Contact', to: '/fnn_portal_representative' },
      { name: 'FAQs', to: '/fnn_portal_faqs' },
    ]
  },
];



export const secondaryRoutes = [
  { name: 'Discover', to: '/mission' },
  { name: 'Career', to: '/news' },
  { name: 'Log in', to: '/hotspot' },
  // { name: 'Stories', to: '/stories' },
  { name: 'HRL Services', to: '/contact' },
  { name: 'HRL Detector', to: '/hrl-detector' },
  { name: 'HRL Wildfire Solutions', to: '/gatorX' },

];

export const allRoutes = [
  { name: 'Home', to: '/' },
  ...mainRoutes,
  ...secondaryRoutes.filter(route => route.name !== 'GatorX'),
];
